<template>
    <div class="d-flex flex-column overflow-hidden h-100">
        <vue-custom-scrollbar
            class="app-content-padding flex-grow-1 overflow-hidden h-100"
        >
            <ts-page-title
                :title="$t('bankProfile.pageTitle')"
                :breadcrumb="[
                    { text: $t('home'), href: '/' },
                    {
                        text: $t('bankProfile.pageTitle'),
                        href: '/admin/bank-profiles'
                    },
                    { text: $t('create'), active: true }
                ]"
            />
            <ts-panel>
                <ts-panel-wrapper>
                    <div class="row">
                        <div class="col-md-6">
                            <label class="required form-col-label control-label">{{
                                $t("bankProfile.bankName")
                            }}</label>
                            <Input
                                v-model="model.bank_name"
                                :placeholder="$t('bankProfile.bankName')"
                                :class="{ 'is-invalid': errors.has('bank_name') }"
                                @on-enter="onSave"
                            />
                            <div class="invalid-feedback" v-if="errors.has('bank_name')">
                                {{ errors.first("bank_name") }}
                            </div>
                            <p class="tw-text-gray-500 tw-text-sm tw-mt-2">
                                <i class="fas fa-info-circle tw-mr-1"></i>
                                {{ $t("bankProfile.createHint") }}
                            </p>
                        </div>
                    </div>
                </ts-panel-wrapper>
            </ts-panel>
        </vue-custom-scrollbar>

        <Spin size="large" fix v-if="loading"></Spin>

        <div
            id="footer"
            class="app-footer m-0 tw-flex tw-justify-end tw-space-x-2"
            style="background-color: #e9ecef"
        >
            <ts-button
                @click.prevent="$router.push({ name: 'bank-profile' })"
                class="btn-gray"
            >
                {{ $t("cancel") }}
            </ts-button>
            <ts-button
                color="primary"
                :waiting="waiting"
                :disabled="waiting"
                @click.prevent="onSave"
            >
                {{ $t("save") }}
            </ts-button>
        </div>
    </div>
</template>

<script>
import AppOptions from "@/config/AppOptions.vue";
import { Errors } from "form-backend-validation";

export default {
    name: "BankProfileCreate",
    data() {
        return {
            loading: false,
            waiting: false,
            errors: new Errors(),
            model: {
                bank_name: ""
            }
        };
    },
    created() {
        AppOptions.appContentFullHeight = true;
        AppOptions.appContentClass = "p-0";
    },
    methods: {
        onSave() {
            this.errors = new Errors();
            this.waiting = true;
            this.$store
                .dispatch("finance/bankProfile/store", this.model)
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    if (response.message_id == 0) {
                        const bankId = response.bank_id || (response.data && response.data.bank_id);
                        this.$store.commit("finance/bankProfile/RESET_STATE");
                        if (bankId) {
                            this.$router.push({
                                name: "bank-profile-edit",
                                params: { id: bankId }
                            });
                        } else {
                            this.$router.push({ name: "bank-profile" });
                        }
                    }
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => (this.waiting = false));
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "BANK PROFILE",
                desc: not.text
            });
        }
    },
    beforeRouteLeave(to, from, next) {
        AppOptions.appContentFullHeight = false;
        AppOptions.appContentClass = "";
        next();
    }
};
</script>
